import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CalculationReturnOfInvestmentsService } from '@/infra/services/calculation-return-of-investments';

type Ergonomic = 'consultancy' | 'internal';

interface UpdateCalculationReturnOfInvestmentsParams {
	id: string;
	name?: string;
	email?: string;
	phone?: string;
	months?: number;
	position?: string;
	company_name?: string;
	num_ergonomist?: number;
	number_of_units?: number;
	total_employees?: number;
	consultancy_value?: number;
	percentage_economy?: number;
	total_workstations?: number;
	base_salary_ergonomist?: number;
	ergonomics_solution_type?: Ergonomic;
}

const Service = CalculationReturnOfInvestmentsService.getInstance();

export const useUpdateCalculationReturnOfInvestments = () => {
	return useMutation({
		mutationFn: async (params: UpdateCalculationReturnOfInvestmentsParams) => Service.update(params),
		onError: () => {
			message.error(I18n.get('Failed to update return of investments'));
		}
	});
};
